import { Component, inject, Input, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActionButtonComponent } from "~app/common/components/action-button/action-button.component";
import { ButtonComponent } from "~app/common/components/button/button.component";
import { CardComponent } from "~app/common/components/cards/card/card.component";
import { CardsComponent } from "~app/common/components/cards/cards.component";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { SelectorComponent } from "~app/common/components/selector/selector.component";
import { ArbetsorderRestriktionStatus, RestriktionsTyper } from "~app/common/models/constants";
import { IOption } from "~app/common/models/options-models";
import { AddArbetsorderRestriktionCommand } from "../commands/AddArbetsorderRestriktionCommand";
import { DeleteArbetsorderRestriktionCommand } from "../commands/DeleteArbetsorderRestriktionCommand";
import { UpdateArbetsorderRestriktionStatusCommand } from "../commands/UpdateArbetsorderRestriktionStatusCommand";
import { IArbetsorderDetail } from "../model/IArbetsorderDetail";
import { IArbetsorderRestriktion } from "../model/IArbetsorderRestriktion";
import { ArbetsorderRestriktionerAnteckningarComponent } from "./arbetsorder-restriktioner-anteckningar/arbetsorder-restriktioner-anteckningar.component";

@Component({
    selector: "rask-arbetsorder-restriktioner",
    imports: [
        ActionButtonComponent,
        ButtonComponent,
        SelectorComponent,
        FormsModule,
        CardComponent,
        CardsComponent
    ],
    templateUrl: "./arbetsorder-restriktioner.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: "./arbetsorder-restriktioner.component.scss"
})
export class ArbetsorderRestriktionerComponent {

    @Input() arbetsorder: IArbetsorderDetail;
    get restriktionsTyper(): IOption[] {
        const valdaTyper = this.arbetsorder.restriktioner.map(y => y.typ);
        const restriktionsTyper = RestriktionsTyper.AllaWithKey.map((x) => ({
            key: x.key,
            value: x.value
        }));
        return restriktionsTyper.filter(x => !valdaTyper.includes(x.key));
    }

    statusar = ArbetsorderRestriktionStatus.alla;

    private readonly raskModalService = inject(RaskModalService);

    protected addRestriktion(item: IOption) {
        this.arbetsorder.restriktioner.push({
            typ: item.key,
            status: ArbetsorderRestriktionStatus.Ejhanterad
        } as IArbetsorderRestriktion);
        this.arbetsorder.commandManager.updateCommand(new AddArbetsorderRestriktionCommand((instance) => {
            instance.arbetsorderId = this.arbetsorder.id;
            instance.typ = item.key;
        }));
    }

    protected restriktionIsDisabled(restriktion: IArbetsorderRestriktion): boolean {
        return restriktion?.atgardRestriktioner?.length > 0 || restriktion?.kartgeometriRestriktioner?.length > 0;
    }

    protected deleteRestriktion(restriktion: IArbetsorderRestriktion) {
        this.arbetsorder.restriktioner.splice(this.arbetsorder.restriktioner.indexOf(restriktion), 1);
        this.arbetsorder.commandManager.updateCommand(new DeleteArbetsorderRestriktionCommand(this.arbetsorder.id, restriktion.typ));
    }

    protected getIcon(status: string) {
        if (status === ArbetsorderRestriktionStatus.Hanterad) {
            return "fa-regular fa-circle-check";
        } else if (status === ArbetsorderRestriktionStatus.Pagar) {
            return "fas fa-circle-half-stroke fa-rotate-270";
        } else {
            return "far fa-circle";
        }
    }

    protected getTypText(typ: string): string {
        return RestriktionsTyper.AllaWithKey.find(x => x.key === typ).value;
    }

    protected UpdateRestriktionSatus(restriktion: IArbetsorderRestriktion, event: any) {
        this.arbetsorder.commandManager.updateCommand(
            new UpdateArbetsorderRestriktionStatusCommand(command => {
                command.status = event;
                command.arbetsorderId = this.arbetsorder.id;
                command.typ = restriktion.typ;
            }));
    }

    protected openAnteckningar(restriktion: IArbetsorderRestriktion) {
        const data = {
            id: restriktion.id,
            arbetsorder: this.arbetsorder
        };
        this.raskModalService.open("Anteckningar", ArbetsorderRestriktionerAnteckningarComponent, "lg", true, data);
    }
}
